import { render, staticRenderFns } from "./control-checkbox.vue?vue&type=template&id=2930c3d2"
import script from "./control-checkbox.vue?vue&type=script&lang=js"
export * from "./control-checkbox.vue?vue&type=script&lang=js"
import style0 from "./control-checkbox.vue?vue&type=style&index=0&id=2930c3d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports